var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginPage"},[_c('HeadInfo',{attrs:{"errorLogin":false}}),_c('div',{staticClass:"messageParty d-flex justify-content-center align-items-center"},[_c('div',{staticStyle:{"font-size":"2rem"},domProps:{"innerHTML":_vm._s(_vm.errorMsg)}})]),_c('FooterInfo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }